module.exports = __webpack_public_path__ + "img/file-upload.bc4f0114.svg";